export const environment = {
    production: false,
    gtmId: 'GTM-KNH97B9G'
  };
  
  export const enum LOG { DEBUG = 0 }
  